import {Component, OnInit} from '@angular/core';
import {ObjectBaseModeComponent} from '../../../../../../core/shared/object/mvs-object-base/object-base-mode.component';

@Component({
    selector: 'bm-customer-billing-transaction-type-base',
    template: '',
    standalone: false
})
export class BmCustomerBillingTransactionTypeBaseComponent extends ObjectBaseModeComponent implements OnInit {

    navigationItems = [
        {
            label: 'Kundentransaktionsart',
            action: 'customerBillingTransactionType',
            tooltip: 'Kundentransaktionsart Details',
            icon: 'fa-solid fa-user-group',
            toggleable: false,
            default: true
        },
        {
            label: 'Abrechnungslauftypen',
            action: 'billingRunType',
            tooltip: 'Abrechnungslauftypen',
            icon: 'fa-solid fa-play',
            toggleable: false,
            default: false
        },
        {
            label: 'SEPA-Entgelte',
            action: 'billingRunTypeSepaCharge',
            tooltip: 'SEPA-Entgelte',
            icon: 'fa-solid fa-euro-sign',
            toggleable: false,
            default: false
        }
    ];

    ngOnInit() {
        super.ngOnInit();
        this.initialized = true;
    }

}
